import React, { useEffect, useState } from "react";
import { Row, Column, Grid, Button } from "carbon-components-react";
import { useFormContext } from "react-hook-form";
import FormInput from "../../components/form_elements/form-input";
import FormDropdown from "../../components/form_elements/form-dropdown";
import FormRadio from "../../components/form_elements/form-radio";
import { useSelector } from "react-redux";
import { buildBeneficiaries } from "../../components/contact-builder";
import FormDatePicker from "../../components/form_elements/form-date-picker";
import EmployeeSelect from "../../components/employee-select";
import FormCheckbox from "../../components/form_elements/form-checkbox";

const BeneficiaryForm = ({ beneficiary, show, relationships, isEmployee, setIsEmployee, countries }) => {
  const { setValue, reset, watch, trigger } = useFormContext();
  const [dependents, setDependents] = useState();
  const [genders, setGenders] = useState([]);
  const [isDependent, setIsDependent] = useState([]);
  const enrollments = useSelector((s) => s.enrollments);
  const [selection, setSelection] = useState(false);
  const [selectedEmployeeGuid, setSelectedEmployeeGuid] = useState();
  const [clear, setClear] = useState(false);
  const { formState} = useFormContext();
  const types = [
    { id: 1, name: "Primary" },
    { id: 2, name: "Contingent" },
  ];
  const [filteredRelationships, setFilteredRelationships] = useState([]);
  const country = watch("country");

  const states = [
    { name: "Alabama", abbreviation: "AL" },
    { name: "Alaska", abbreviation: "AK" },
    { name: "Arizona", abbreviation: "AZ" },
    { name: "Arkansas", abbreviation: "AR" },
    { name: "California", abbreviation: "CA" },
    { name: "Colorado", abbreviation: "CO" },
    { name: "Connecticut", abbreviation: "CT" },
    { name: "Delaware", abbreviation: "DE" },
    { name: "District Of Columbia", abbreviation: "DC" },
    { name: "Florida", abbreviation: "FL" },
    { name: "Georgia", abbreviation: "GA" },
    { name: "Hawaii", abbreviation: "HI" },
    { name: "Idaho", abbreviation: "ID" },
    { name: "Illinois", abbreviation: "IL" },
    { name: "Indiana", abbreviation: "IN" },
    { name: "Iowa", abbreviation: "IA" },
    { name: "Kansas", abbreviation: "KS" },
    { name: "Kentucky", abbreviation: "KY" },
    { name: "Louisiana", abbreviation: "LA" },
    { name: "Maine", abbreviation: "ME" },
    { name: "Maryland", abbreviation: "MD" },
    { name: "Massachusetts", abbreviation: "MA" },
    { name: "Michigan", abbreviation: "MI" },
    { name: "Minnesota", abbreviation: "MN" },
    { name: "Mississippi", abbreviation: "MS" },
    { name: "Missouri", abbreviation: "MO" },
    { name: "Montana", abbreviation: "MT" },
    { name: "Nebraska", abbreviation: "NE" },
    { name: "Nevada", abbreviation: "NV" },
    { name: "New Hampshire", abbreviation: "NH" },
    { name: "New Jersey", abbreviation: "NJ" },
    { name: "New Mexico", abbreviation: "NM" },
    { name: "New York", abbreviation: "NY" },
    { name: "North Carolina", abbreviation: "NC" },
    { name: "North Dakota", abbreviation: "ND" },
    { name: "Ohio", abbreviation: "OH" },
    { name: "Oklahoma", abbreviation: "OK" },
    { name: "Oregon", abbreviation: "OR" },
    { name: "Pennsylvania", abbreviation: "PA" },
    { name: "Rhode Island", abbreviation: "RI" },
    { name: "South Carolina", abbreviation: "SC" },
    { name: "South Dakota", abbreviation: "SD" },
    { name: "Tennessee", abbreviation: "TN" },
    { name: "Texas", abbreviation: "TX" },
    { name: "Utah", abbreviation: "UT" },
    { name: "Vermont", abbreviation: "VT" },
    { name: "Virginia", abbreviation: "VA" },
    { name: "Washington", abbreviation: "WA" },
    { name: "West Virginia", abbreviation: "WV" },
    { name: "Wisconsin", abbreviation: "WI" },
    { name: "Wyoming", abbreviation: "WY" },
  ];

  useEffect(() => {
    console.log(isEmployee);
    if (Array.isArray(enrollments)) return;
    setValue("useEmployeeAddress", false);

    if (!show) {
      reset();
      setValue("selectedEmployee", null);
      setSelectedEmployeeGuid(undefined);
      setDependents(null);
      setGenders(null);
      setValue("birthdate", null);
      setIsEmployee(false);
      setClear(true);
      return;
    }
    setDependents(enrollments?.contacts);
    if(relationships)
      setRelationships();
    setGenders(enrollments?.genders);
    setDependent(beneficiary);
    console.log(beneficiary);
  }, [show]);

  useEffect(() => {
    if(relationships)
      setRelationships();
  }, [relationships]);

  useEffect(() => {
    if(clear === true){
      reset();
      setClear(false);
    }
  }, [clear]);

  useEffect(() => {
    if(selectedEmployeeGuid !== undefined){
    setValue("firstName", selectedEmployeeGuid.firstName);
    setValue("lastName", selectedEmployeeGuid.lastName);
    setValue("id", selectedEmployeeGuid.id);
    setValue("relationship", selectedEmployeeGuid.relationship.id);
    setValue("genderId", selectedEmployeeGuid.gender.id);
    setValue("birthdate", selectedEmployeeGuid.birthdate);
    setValue("ssn", selectedEmployeeGuid.ssn);
    setValue("isEmployee", selectedEmployeeGuid.isEmployee);
    setValue("addressLine1", selectedEmployeeGuid?.address?.addressLine1);
    setValue("addressLine2", selectedEmployeeGuid?.address?.addressLine2);
    setValue("city", selectedEmployeeGuid?.address?.city);
    setValue("state", selectedEmployeeGuid?.address?.state);
    setValue("postalCode", selectedEmployeeGuid?.address?.postalCode);
    setValue("country", selectedEmployeeGuid?.address?.country);

    }

}, [selectedEmployeeGuid]);

  const populateFields = (person) => {
    setValue("id", person?.id);
    setValue("firstName", person?.firstName);
    setValue("lastName", person?.lastName);
    setValue("relationship", person?.relationship?.id);
    setValue("ssn", person?.ssn);
    setValue("type", person?.type);
    setValue("genderId", person?.gender?.id);
    setValue("birthdate", person?.birthdate);
    setValue("percentage", person?.percentage);
    setValue("isEmployee", person?.isEmployee);
    setValue("addressLine1", person?.address?.addressLine1);
    setValue("addressLine2", person?.address?.addressLine2);
    setValue("city", person?.address?.city);
    setValue("state", person?.address?.state);
    setValue("region", person?.address?.region);
    setValue("postalCode", person?.address?.postalCode);
    setValue("country", person?.address?.country ?? "US");
  };
  const setDependent = (person) => {
    setIsDependent(enrollments?.dependents?.some((s) => s === person.id));
    populateFields(person);
  }
  const clearDependent = () => {
    populateFields(null);
    setIsDependent(null);
    setValue("dependent", null);

  }

  const updateAddress = (e) => {
    if(e === true) {
      setValue("addressLine1", enrollments.employee.addressLine1);
      setValue("addressLine2", enrollments.employee.addressLine2);
      setValue("city", enrollments.employee.city);
      setValue("state", enrollments.employee.state);
      setValue("region", enrollments.employee.region);
      setValue("postalCode", enrollments.employee.postalCode);
      setValue("country", enrollments.employee.country);
    } else {
      setValue("addressLine1", null);
      setValue("addressLine2", null);
      setValue("city", null);
      setValue("state", null);
      setValue("region", null);
      setValue("postalCode", null);
      setValue("country", "US");
    }
  }

  const setRelationships = () => {
    const beneficiaries = buildBeneficiaries(enrollments);
    let activeContacts = [];
    activeContacts = activeContacts
      .concat(enrollments.dependents)
      .concat(beneficiaries.map((s) => s.id));
    activeContacts = [...new Set(activeContacts)];
    const isSpouse = beneficiary?.relationship?.id === "S";
    const hasSpouse = enrollments.contacts
      ?.filter((s) => activeContacts.indexOf(s.id) !== -1)
      .some((s) => s.relationship.id === "S");

    if (!isSpouse && hasSpouse)
      setFilteredRelationships(relationships?.filter((s) => s.id !== "S"));
    else setFilteredRelationships(relationships);
  };

  return (
    <Grid narrow className="mb-20">
      {!beneficiary?.id ? 
      <>
        {isEmployee !== true ?
          <Row>
            <Column>
              <FormDropdown
                onChange={(e) => {
                  setDependent(e.selectedItem);
                }}
                itemToString={(item) => item?.firstName + " " + item?.lastName}
                label="Select from dependents"
                name="dependent"
                items={dependents}
              />
            </Column>
          </Row>
        : 
          <></>
        }
          
      {
        !isDependent ? 
        <>
        {isEmployee !== true ?
          <div className="mb-4">
            OR
          </div> :<></>
        }
        <Row>
          <Column>
            <EmployeeSelect setClear={setClear} selectedEmployeeGuid={selectedEmployeeGuid} setIsEmployee={setIsEmployee} setSelectedEmployeeGuid={setSelectedEmployeeGuid} />
          </Column>
        </Row>
        
        {isEmployee !== true ?
          <>
            <Row>
              <h6 className="font-normal text-inherit pl-6 mb-3">OR</h6>
            </Row>
            <Row>
              <h6 className="text-inherit text-xs font-normal mb-3">
                Create New Record
              </h6>
            </Row>
          </>:<></>
        }
        </>
      :<>              
        <Button kind="ghost" size="sm" onClick={clearDependent}>Clear Dependent</Button>
      </>}
              </>:<></>
      }

      {
        !isDependent ? (
          <>
          <Row>
            <Column>
              <FormInput name="firstName" label="First Name (Legal)*" disabled={isEmployee} props={{ maxLength: "25" }} />
            </Column>
            <Column>
              <FormInput name="lastName" label="Last Name (Legal)*" disabled={isEmployee} props={{ maxLength: "25" }} />
            </Column>
          </Row>

          <Row>
            <Column>
              <FormDropdown label="Relationship*"  name="relationship" items={filteredRelationships} />
            </Column>
          </Row>
          {isEmployee !== true ?
          <>

          <Row>
            <Column>
              <FormDropdown label="Gender *" name="genderId" items={genders} disabled={isEmployee} />
            </Column>
          </Row>
          <Row>
              <Column>
                <div className="mb-6">
                  <FormDatePicker name="birthdate" label="Date of Birth *"  minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 100)).toLocaleDateString()} maxDate={new Date().toLocaleDateString()} disabled={isEmployee} /> 
                </div>
              </Column>
          </Row>
          </>:<></>}
        </>
      ) : (
        <Row>
          <Column className="mb-4 text-md">
            {beneficiary?.firstName} {beneficiary?.lastName}
          </Column>
        </Row>
      )}
      <Row>
        <Column>
          <FormRadio name="type" label="Beneficiary Type*" options={types} />
        </Column>
        <Column className="mt-2">
          <FormInput
              name="percentage"
              type="number"
              label="% of Benefit*"
              props={{ step: "1", pattern: "[0-9]*" }}
            />        
          </Column>
      </Row>
      {isEmployee !== true ?
      <>
        {!isDependent ? (
          <Row>
            <Column>
              <FormInput name="ssn" type="ssn" label="Socal Security Number" disabled={isEmployee} />
            </Column>
          </Row>
        ) : (
          <></>
        )}
      <Row>
        <Column>
          <FormCheckbox label="Use My Address" name="useEmployeeAddress" disabled={isEmployee} onChange={updateAddress} />
        </Column>
      </Row>
      <Row>
      <span className="text-danger text-sm pb-4">
          {
          formState.errors["address"]?.message
          }
        </span>
        </Row>
      <Row>
        <Column>
          <FormDropdown label="Country*"  name="country" items={countries} />
        </Column>
      </Row>


      <Row>
        <Column>
          <FormInput name="addressLine1" label="Address Line 1*" props={{ maxLength: "40" }}  disabled={isEmployee}  />
        </Column>
      </Row>
      <Row>
        <Column>
          <FormInput name="addressLine2" label="Address Line 2" props={{ maxLength: "40" }} disabled={isEmployee} />
        </Column>
      </Row>
      <Row>
        <Column>
          <FormInput label="City*" name="city" disabled={isEmployee} />
        </Column>
      </Row>
      <Row>
        {country === "US" ?
        <Column>
          <FormDropdown
            itemValueField="abbreviation"
            itemTextField="abbreviation"
            helperText={"Select a State"}
            label="State*"
            name="state"
            items={states}
            disabled={isEmployee}
            />
        </Column>
        :
        <Column>
          <FormInput name="region" label="Region/State/Province*" disabled={isEmployee} />
        </Column>
        }
        <Column>
          <FormInput name="postalCode" label={country === "US" ? "Zip Code*" : "Postal Code*"} disabled={isEmployee} />
        </Column>
      </Row>
      </>:<></>}
    </Grid>
  );
};

export default BeneficiaryForm;
